export default [
    {
      id: 1,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1649443651/react%20dnd/DTS_The_Green_Copson_Londan_5077.jpg",
      title: "Eazilive"  
    },
    {
      id: 2,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1649443650/react%20dnd/DTS_Closer_Parole_Dure_5144.jpg",
      title: "Sportman"  
    },
    {
      id: 3,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1649443650/react%20dnd/DTS_Misc_1__Nich_Fancher__Nick_Fancher_4532.jpg",
      title: "Mabjay"  
    },
    {
      id: 4,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1649443800/react%20dnd/_MG_9747_nk0tz2_c_scale_w_509.jpg",
      title: "Dinar"  
    },
    {
      id: 5,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1649443651/react%20dnd/DTS_Pride_AgustA%CC%83_n_Farias_5543.jpg",
      title: "Developer"  
    },
    {
      id: 6,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1642955238/image-placeholders/teri.jpg",
      title: "Coder"   
    },
    {
      id: 7,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1649443800/react%20dnd/teri_mgjkie_c_scale_w_527.jpg",
      title: "Sudaiz"    
    },
    {
      id: 8,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1649432567/react%20dnd/pexels-vitalina-9197509.jpg",
      title: "Riyadh"  
    },
    {
      id: 9,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1649432565/react%20dnd/pexels-ali-pazani-3280132.jpg",
      title: "Miami"  
    },
    {
      id: 10,
      img:
        "https://cloudinary-res.cloudinary.com/image/upload/bo_1px_solid_black,a_0/f_auto,q_auto/docs/media_library_widget/cms_media_library_demo.png",
      title: "Rajab"  
    },
    {
      id: 10,
      img:
        "https://res.cloudinary.com/terieyenike/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1649443650/react%20dnd/DTS_Misc_1__Nich_Fancher__Nick_Fancher_4532.jpg",
      title: "Lamlad-Atlantic"  
    },
    {
      id: 10,
      img:
        "//media.istockphoto.com/photos/beautiful-view-of-amazing-sandstone-formations-in-famous-lower-near-picture-id807387518?k=20&m=807387518&s=612x612&w=0&h=G8O867Id71Sk6LCiAnAYp-dIu9uf4YqlfnO3uj-SQ00=",
      title: "Cloudar"  
    }
  ];
  